// Mock data for DMV-Lernportal (based on Readle functionality)

export const languages = [
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', color: '#4ECDC4' },
  { code: 'fr', name: 'Französisch', flag: '🇫🇷', color: '#4ECDC4' },
  { code: 'en', name: 'Englisch', flag: '🇺🇸', color: '#4ECDC4' },
  { code: 'tr', name: 'Türkisch', flag: '🇹🇷', color: '#4ECDC4' }
];

export const levels = [
  { code: 'A1', name: 'Anfänger', description: 'Grundlagen' },
  { code: 'A2', name: 'Grundlagen', description: 'Erweiterte Grundlagen' },
  { code: 'B1', name: 'Mittelstufe', description: 'Selbstständige Sprachverwendung' },
  { code: 'B2', name: 'Oberstufe', description: 'Fließende Sprachverwendung' },
  { code: 'C1', name: 'Fortgeschritten', description: 'Kompetente Sprachverwendung' }
];

export const grammarTopics = {
  'A1': [
    'Artikel (der, die, das)',
    'Personalpronomen',
    'Präsens',
    'Sein und Haben',
    'Grundwortstellung'
  ],
  'A2': [
    'Perfekt',
    'Modalverben',
    'Akkusativ und Dativ',
    'Possessivpronomen',
    'Präpositionen'
  ],
  'B1': [
    'Konjunktiv II',
    'Passiv',
    'Relativsätze',
    'Indirekte Rede',
    'Temporale Konjunktionen'
  ],
  'B2': [
    'Konjunktiv I',
    'Partizipialkonstruktionen',
    'Nominalisierung',
    'Kausale Zusammenhänge',
    'Subjektive Modalverben'
  ],
  'C1': [
    'Erweiterte Passivformen',
    'Komplexe Satzstrukturen',
    'Stilistische Varianten',
    'Funktionsverbgefüge',
    'Metaphorische Sprache'
  ]
};

export const stories = [
  {
    id: 1,
    title: 'Der schottische Ausdruck für "Ich habe deinen Namen vergessen"',
    description: 'Bonnie, eine Studentin der Geschichte, entdeckt ein altes Familiengeheimnis.',
    level: 'A1',
    language: 'de',
    readTime: '3 Min',
    image: 'https://images.unsplash.com/photo-1534447677768-be436bb09401?w=400',
    content: `Es gibt einen schottischen Ausdruck für "Ich habe deinen Namen vergessen": tartle. Bonnie kannte dieses Wort nicht, aber sie erlebte es jeden Tag.

Sie war Studentin an der Universität Edinburgh und studierte Geschichte. Jeden Morgen ging sie zur Bibliothek. Dort sah sie viele Gesichter, aber sie konnte sich nicht an die Namen erinnern.

"Guten Morgen", sagte ein Junge zu ihr.
"Guten Morgen", antwortete Bonnie und lächelte freundlich.

Sie kannte sein Gesicht, aber wie hieß er nur? Das war ein Problem für sie. Sie wollte höflich sein, aber sie hatte seinen Namen vergessen.

Eines Tages fand Bonnie ein altes Buch in der Bibliothek. Es war über schottische Traditionen. Dort las sie das Wort "tartle" zum ersten Mal.

"Das bin ich!", dachte sie und lachte.

Von diesem Tag an fühlte sie sich besser. Es gab ein Wort für ihr Problem. Sie war nicht allein.`,
    words: [
      { word: 'Ausdruck', translation: 'expression', selected: false, sentence: 'Es gibt einen schottischen Ausdruck für "Ich habe deinen Namen vergessen"' },
      { word: 'vergessen', translation: 'forgotten', selected: false, sentence: 'Ich habe deinen Namen vergessen' },
      { word: 'Studentin', translation: 'student (female)', selected: false, sentence: 'Sie war Studentin an der Universität Edinburgh' },
      { word: 'erinnern', translation: 'remember', selected: false, sentence: 'sie konnte sich nicht an die Namen erinnern' },
      { word: 'höflich', translation: 'polite', selected: false, sentence: 'Sie wollte höflich sein' }
    ],
    grammarFocus: ['Artikel (der, die, das)', 'Präsens', 'Sein und Haben'],
    sentences: [
      {
        text: 'Es gibt einen schottischen Ausdruck für "Ich habe deinen Namen vergessen": tartle.',
        grammarTopics: ['Artikel (der, die, das)', 'Präsens']
      },
      {
        text: 'Sie war Studentin an der Universität Edinburgh und studierte Geschichte.',
        grammarTopics: ['Sein und Haben', 'Präsens']
      }
    ]
  },
  {
    id: 2,
    title: 'Bauern in Kolumbien setzen auf Umweltschutz',
    description: 'Eine Geschichte über nachhaltige Landwirtschaft und Umweltbewusstsein.',
    level: 'B1',
    language: 'de',
    readTime: '5 Min',
    image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=400',
    content: `Die Bauern in Kolumbien haben eine neue Strategie entwickelt. Sie konzentrieren sich jetzt auf den Umweltschutz, während sie ihre Landwirtschaft betreiben.

Maria Santos ist eine dieser Bäuerinnen. Sie lebt in den Bergen von Kolumbien und baut Kaffee an. Früher verwendete sie viele Chemikalien für ihre Pflanzen.

"Ich dachte, das wäre der beste Weg", erklärt sie. "Aber dann habe ich gelernt, dass es der Umwelt schadet."

Vor drei Jahren begann Maria, ihre Methoden zu ändern. Sie lernte von anderen Bauern, die bereits umweltfreundliche Techniken verwendeten.

Heute verwendet sie natürliche Düngemittel und verzichtet auf schädliche Chemikalien. Ihre Kaffeepflanzen sind gesünder, und die Umgebung ist sauberer geworden.

"Meine Kinder können jetzt sicher in den Feldern spielen", sagt Maria stolz.

Die Veränderung war nicht einfach. Am Anfang war die Ernte kleiner. Aber Maria gab nicht auf. Sie experimentierte mit verschiedenen Methoden und lernte von ihren Fehlern.

Heute verdient sie sogar mehr Geld als früher. Umweltfreundlicher Kaffee wird zu höheren Preisen verkauft.`,
    words: [
      { word: 'Strategie', translation: 'strategy', selected: false, sentence: 'Die Bauern in Kolumbien haben eine neue Strategie entwickelt' },
      { word: 'Umweltschutz', translation: 'environmental protection', selected: false, sentence: 'Sie konzentrieren sich jetzt auf den Umweltschutz' },
      { word: 'Chemikalien', translation: 'chemicals', selected: false, sentence: 'Früher verwendete sie viele Chemikalien für ihre Pflanzen' },
      { word: 'schädlich', translation: 'harmful', selected: false, sentence: 'verzichtet auf schädliche Chemikalien' },
      { word: 'experimentierte', translation: 'experimented', selected: false, sentence: 'Sie experimentierte mit verschiedenen Methoden' }
    ],
    grammarFocus: ['Perfekt', 'Relativsätze', 'Temporale Konjunktionen'],
    sentences: [
      {
        text: 'Die Bauern in Kolumbien haben eine neue Strategie entwickelt.',
        grammarTopics: ['Perfekt']
      },
      {
        text: 'Sie lernte von anderen Bauern, die bereits umweltfreundliche Techniken verwendeten.',
        grammarTopics: ['Relativsätze']
      }
    ]
  },
  {
    id: 3,
    title: 'Le petit café du coin',
    description: 'Une histoire sur un petit café parisien et ses habitués.',
    level: 'A2',
    language: 'fr',
    readTime: '4 Min',
    image: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=400',
    content: `Il était une fois un petit café au coin de la rue Saint-Antoine à Paris. Ce café s'appelait "Chez Marcel" et il existait depuis plus de cinquante ans.

Marcel, le propriétaire, était un homme de soixante-dix ans. Chaque matin, il ouvrait son café à six heures précises. Il préparait le café avec soin et disposait les croissants frais sur le comptoir.

Les habitués arrivaient toujours aux mêmes heures. Madame Dubois venait à sept heures pour son café au lait. Monsieur Martin passait à huit heures avant d'aller au travail.

"Bonjour Marcel !" disaient-ils en entrant.
"Bonjour mes amis !" répondait Marcel avec un grand sourire.

Un jour, Marcel tomba malade. Le café resta fermé pendant une semaine. Les habitués ne savaient pas quoi faire. Ils se rencontraient devant la porte fermée et parlaient de Marcel.

Quand Marcel revint, tout le monde était content. Les clients avaient apporté des fleurs et des gâteaux.

"Merci mes amis", dit Marcel, les larmes aux yeux. "Ce café, c'est notre maison à tous."`,
    words: [
      { word: 'propriétaire', translation: 'owner', selected: false, sentence: 'Marcel, le propriétaire, était un homme de soixante-dix ans' },
      { word: 'habitués', translation: 'regulars', selected: false, sentence: 'Les habitués arrivaient toujours aux mêmes heures' },
      { word: 'précises', translation: 'precise', selected: false, sentence: 'il ouvrait son café à six heures précises' },
      { word: 'comptoir', translation: 'counter', selected: false, sentence: 'disposait les croissants frais sur le comptoir' },
      { word: 'larmes', translation: 'tears', selected: false, sentence: 'dit Marcel, les larmes aux yeux' }
    ],
    grammarFocus: ['Imparfait', 'Passé composé', 'Articles définis'],
    sentences: [
      {
        text: 'Marcel, le propriétaire, était un homme de soixante-dix ans.',
        grammarTopics: ['Imparfait', 'Articles définis']
      },
      {
        text: 'Un jour, Marcel tomba malade.',
        grammarTopics: ['Passé composé']
      }
    ]
  }
];

export const userProgress = {
  currentLanguage: 'de',
  currentLevel: 'A1',
  completedStories: [1],
  learnedWords: 25,
  streak: 7,
  totalReadingTime: 45 // minutes
};

export const flashcards = [
  {
    id: 1,
    word: 'Ausdruck',
    translation: 'expression',
    sentence: 'Es gibt einen schottischen Ausdruck für "Ich habe deinen Namen vergessen"',
    difficulty: 1,
    nextReview: new Date(Date.now() + 24 * 60 * 60 * 1000) // tomorrow
  },
  {
    id: 2,
    word: 'vergessen',
    translation: 'forgotten',
    sentence: 'Ich habe deinen Namen vergessen',
    difficulty: 2,
    nextReview: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000) // 3 days
  }
];